import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, switchMap } from 'rxjs';
import { HeaderType, RouteData } from 'src/app/types/route';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  showHeader: boolean | 'desktop' | 'mobile' = false;
  headerType: HeaderType = HeaderType.Landing;
  showFooter = false;
  showToTopButton = false;
  urlToNavOnClose: string[] = [];
  isInIframe = false;
  productId: string | undefined;
  backFn: (() => void) | undefined;
  isMobileMenuOpened = false;
  showCookieBanner = true;

  route = inject(ActivatedRoute);
  router = inject(Router);

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        switchMap(() => {
          let resultRoute = this.route.firstChild;

          if (!resultRoute) throw new Error('');

          while (resultRoute.firstChild) resultRoute = resultRoute.firstChild;

          return resultRoute.data;
        }),
      )
      .subscribe(
        ({
          showHeader,
          headerType,
          showFooter,
          showToTopButton,
          urlToNavOnClose,
        }: RouteData) => {
          this.showHeader = showHeader ?? false;
          this.headerType = headerType ?? HeaderType.Landing;
          this.showFooter = showFooter ?? false;
          this.showToTopButton = showToTopButton ?? false;
          this.urlToNavOnClose = urlToNavOnClose ?? ['/'];

          this.isMobileMenuOpened = false;
        },
      );

    this.route.queryParamMap.subscribe(() => {
      this.isInIframe = Boolean(window.self !== window.top);
    });
  }

  closeSelf() {
    if (!this.isInIframe) return;
    if (!parent.top) return;

    parent.top.postMessage({ event: 'Close' });
  }

  onBack() {
    if (this.backFn) this.backFn();
  }
}
